import store from "@/core/store"
import {SET_ERROR_STATUS_CODE} from "@/core/store/modules/errors/constants";

export default function permissions({to, next, router}) {
    if (typeof to.meta.permissions == 'undefined') {
        return next();
    }

    let and = false
    let hasAccess = true
    if (typeof to.meta.has_all_permissions != 'undefined' && to.meta.has_all_permissions) {
        and = true;
    }

    if (and) {
        to.meta.permissions.map((permission) => {
            if (!Object.values(store.getters.permissions).includes(permission)) {
                hasAccess = false
            }
        })

    } else {
        hasAccess = Object.keys(to.meta.permissions)
            .some((key) => {
                return Object.values(store.getters.permissions).includes(to.meta.permissions[key])
            });

    }

    if (hasAccess) {
        return next();
    } else {
        store.commit(SET_ERROR_STATUS_CODE, 403)
        router.push({
            name: "errors.forbidden"
        }).catch(() => {
        })
    }


}